import { render, staticRenderFns } from "./finalStep.vue?vue&type=template&id=e312f8b2"
import script from "./finalStep.vue?vue&type=script&lang=js"
export * from "./finalStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports